import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/caisse.service';



export const createDocClient = createAsyncThunk(
    "Caisse/adm-createDoc",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createDoc(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateDocClient = createAsyncThunk(
    "Caisse/adm-updateDoc",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateDoc(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewDocClient = createAsyncThunk(
    "Caisse/adm-viewDoc",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewDoc(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const filterDocClient = createAsyncThunk(
    "Caisse/adm-filterDoc",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.filterDoc(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listAcompteReady = createAsyncThunk(
    "Caisse/adm-listAcompteReady",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listAcompteReady(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createAcompteClient = createAsyncThunk(
    "Caisse/adm-createAcompte",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createAcompte(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const filterAcompteClient = createAsyncThunk(
    "Caisse/adm-filterAcompte",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.filterAcompte(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createPaiementClient = createAsyncThunk(
    "Caisse/adm-createPaiement",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createPaiement(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const validatePaiementClient = createAsyncThunk(
    "Caisse/adm-validatePaiement",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.validatePaiement(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const annulerPaiementClient = createAsyncThunk(
    "Caisse/adm-annulerPaiement",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.annulerPaiement(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listPaiementCheque = createAsyncThunk(
    "Caisse/adm-listPaiementCheque",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listPaiementCheque(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const filterMvmCaisse = createAsyncThunk(
    "Caisse/adm-filterMvm",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.filterMvm(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const tranformDevisClient = createAsyncThunk(
    "Caisse/adm-tranformDevis",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.tranformDevis(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const facturerDocClient = createAsyncThunk(
    "Caisse/adm-facturerDocClient",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.facturerDoc(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const annulerDocClient = createAsyncThunk(
    "Caisse/adm-annulerDocClient",

    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.annulerDoc(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewFactureClient = createAsyncThunk(
    "Caisse/adm-viewFactureClient",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewFactureClient(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createAvoirClient = createAsyncThunk(
    "Caisse/adm-createAvoir",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createAvoir(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const filterAvoirClient = createAsyncThunk(
    "Caisse/adm-filterAvoir",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.filterAvoir(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewAvoirClient = createAsyncThunk(
    "Caisse/adm-viewAvoir",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAvoir(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const getDispoAvoirByClient = createAsyncThunk(
    "Caisse/adm-getDispoAvoirByClient",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getDispoAvoirByClient(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)




export const createDocRelance = createAsyncThunk(
    "Caisse/adm-createRelance",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createRelance(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateDocRelance = createAsyncThunk(
    "Caisse/adm-updateRelance",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateRelance(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const deleteDocRelance = createAsyncThunk(
    "Caisse/adm-deleteRelance",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.deleteRelance(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listDocRelance = createAsyncThunk(
    "Caisse/adm-listRelance",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listRelance(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const envoyerDocMail = createAsyncThunk(
    "Caisse/adm-envoyerDocMail",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.envoyerDocMail(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)





const initialState = {
    loading: false,
    error: '',
    sel_Caisse: null
}

const CaisseSlice = createSlice({
    name: "Caisse",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },
        set_error: (state , action) => {
            state.error = action.payload
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = CaisseSlice;
export const { clear, set_error } = CaisseSlice.actions;
export default reducer;